import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../axiosBaseQuery';

// ---------- Types ----------
export interface PortLocation {
  id: number;
  name: string;
}

export interface PortLocationsResponse {
  success: boolean;
  message: string;
  data: PortLocation[];
  timestamp: string;
  errors: null;
  requestId: string;
}

export interface PortOption {
  value: string;
  label: string;
}

// ---------- API Slice ----------
const portsApi = createApi({
  reducerPath: 'portsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['PortLocations'],
  endpoints: (builder) => ({
    getPortLocations: builder.query<PortOption[], { search?: string }>({
      query: ({ search = '' }) => ({
        url: 'vessels/location/names',
        method: 'GET',
        params: search ? { search } : {},
      }),
      transformResponse: (res: PortLocationsResponse): PortOption[] => {
        if (!res?.success || !Array.isArray(res.data)) {
          return [];
        }
        return res.data.map((port: PortLocation) => ({
          value: port.id.toString(),
          label: port.name,
        }));
      },
      providesTags: ['PortLocations'],
    }),
  }),
});

// ---------- Reducer, Middleware, Path ----------
export const portsReducer = portsApi.reducer;
export const portsMiddleware = portsApi.middleware;
export const portsReducerPath = portsApi.reducerPath;

// ---------- Hooks / Actions ----------
export const { useGetPortLocationsQuery } = portsApi;
